// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h7ah","comment":"styles_comment__1WgeG"};